import { render } from "./MainUnitMeasures.vue?vue&type=template&id=661dacae&scoped=true"
import script from "./MainUnitMeasures.vue?vue&type=script&lang=js"
export * from "./MainUnitMeasures.vue?vue&type=script&lang=js"

import "./MainUnitMeasures.vue?vue&type=style&index=0&id=661dacae&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661dacae"]])

export default __exports__